// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"dbcec3c831adc5fa71e8","293":"1bfb355e1cfca7a84d22","518":"bb2a023e86dfb9283622","779":"83280ed1b6fc5d464be4"}[chunkId] + ".js";
};